import { motion } from 'motion/react';
import { Container } from './primitives';

const FIRMS = [{ name: 'Almacis', tag: 'Imprese generali' }];

export function TrustStrip() {
  return (
    <section className="relative border-y border-border bg-secondary/40 py-10">
      <Container>
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <p className="max-w-[280px] font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            <span className="text-primary">▲</span> &nbsp; In pilotaggio con
          </p>
          <motion.ul
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.5 }}
            variants={{ show: { transition: { staggerChildren: 0.07 } } }}
            className="grid grid-cols-2 gap-x-10 gap-y-4 md:flex md:flex-wrap md:gap-x-12"
          >
            {FIRMS.map((f) => (
              <motion.li
                key={f.name}
                variants={{
                  hidden: { opacity: 0, y: 8 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
                }}
                className="flex flex-col"
              >
                <span className="text-[18px] font-medium leading-none tracking-tight text-fg-2">
                  {f.name}
                </span>
                <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.18em] text-fg-disabled">
                  {f.tag}
                </span>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </Container>
    </section>
  );
}
